// @flow
import styled from 'styled-components';

export const Inner = styled.div`
> div {
  ${({ bottomMargin }) => bottomMargin && `margin-bottom: 42px;`}
  }
`;
